'use-strict';

/* @ngInject */
export default function CarSelectController(
  $scope,
  toastService,
) {
  $scope.cars = null;
  $scope.searchResults = null;
  $scope.overlay = false;
  $scope.selectedCar = null;
  $scope.inputRequired = $scope.required === 'true';
  $scope.searchPhrase = '';
  $scope.ready = false;

  const directiveInit = () => { };

  $scope.initCar = (car) => {
    $scope.selectedCar = car;
  };

  $scope.searchCar = () => {
    const lowerCaseSearchPhrase = $scope.searchPhrase.toLowerCase();
    if (lowerCaseSearchPhrase === '') $scope.searchResults = $scope.cars;

    $scope.searchResults = $scope.cars.filter((c) => {
      if (c.vin && c.vin.toLowerCase().includes(lowerCaseSearchPhrase)) return true;

      if ($scope.additionalSearchParam !== undefined) {
        switch ($scope.additionalSearchParam) {
          case 'licence':
            if (!c.vehicleData.registration.licence) return false;
            if (c.vehicleData.registration.licence.toLowerCase().includes(lowerCaseSearchPhrase)) {
              return true;
            }
            break;

          default:
            break;
        }
      }

      return false;
    });
  };

  /**
   * If provided as a param, try to find the provided vin in the data and preselect the car.
   */
  const findSearchInit = () => {
    if ($scope.vinInit !== undefined) {
      const foundCar = $scope.cars.find((c) => c.vin === $scope.vinInit);
      if (foundCar !== undefined) {
        $scope.selectCar(foundCar.id);
      } else {
        toastService.toast('error', 'Das gewählte Fahrzeuge konnte nicht gefunden werden. Ggf. muss der Import manuell angestoßen werden.');
      }
    } else {
      $scope.searchCar();
    }
  };

  $scope.saveCars = (cars) => {
    $scope.cars = cars;
    findSearchInit();
  };

  $scope.deselectItem = () => {
    $scope.fsModel = undefined;
    $scope.selectedCar = null;
  };

  $scope.selectCar = (_id) => {
    $scope.fsModel = _id;
    $scope.selectedCar = $scope.cars.find((c) => c._id === _id);
    $scope.hideOverlay();
  };

  $scope.openOverlay = () => {
    $scope.overlay = true;
  };

  $scope.hideOverlay = () => {
    $scope.overlay = false;
  };

  directiveInit();
}
